import React, { useState, useEffect, memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useHistory } from "../Components/HistoryContext";
import videoData from "../Components/SearchVideo.json";
import "./PageVideo.css";

const PageVideo = memo(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const { addToHistory } = useHistory();
  const searchTerm = location.state?.searchTerm?.toLowerCase() || "default";
  const language = location.state?.language?.toLowerCase() || localStorage.getItem("userLanguage")?.toLowerCase() || "english";
  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const normalizedSearchTerm = searchTerm.toLowerCase();

    // Debug logs
    console.log("Search Term:", normalizedSearchTerm);
    console.log("Language:", language);
    if (!videoData.videos) {
      console.error("videoData.videos is undefined");
      setVideos([]);
      setIsLoading(false);
      return;
    }

    // Filter videos
    const videoResults = (videoData.videos[normalizedSearchTerm] || []).filter(video => {
      const matchesLanguage = language === "both" || video.language.toLowerCase() === language;
      console.log(`Video: ${video.title}, Language: ${video.language}, Matches: ${matchesLanguage}`);
      return matchesLanguage;
    });

    setVideos(videoResults);
    setIsLoading(false);
  }, [searchTerm, language]);

  const handleVideoClick = (src, title) => {
    addToHistory({ src, title });
    navigate(`/video/${encodeURIComponent(title)}`, {
      state: { videoSrc: src, videoTitle: title },
    });
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="search-results-container">
        <button className="back-button" onClick={handleBack} aria-label="Go back">
          ← Back
        </button>
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Searching for "{searchTerm}"...</p>
        </div>
      </div>
    );
  }

  const totalResults = videos.length;

  return (
    <div className="search-results-container">
      <button className="back-button" onClick={handleBack} aria-label="Go back">
        ← Back
      </button>
      <div className="search-header">
        <h1 className="search-title">Results for "{searchTerm}"</h1>
        <p className="results-count">{totalResults} {totalResults === 1 ? "result" : "results"}</p>
      </div>
      {totalResults > 0 ? (
        <div className="content-layout">
          {videos.map((video, index) =>
            video?.thumbnail && video?.src && video?.title ? (
              <div
                key={`video-${video.src}-${index}`}
                className="media-card"
                onClick={() => handleVideoClick(video.src, video.title)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => e.key === "Enter" && handleVideoClick(video.src, video.title)}
                aria-label={`Play video: ${video.title}`}
              >
                <div className="thumbnail-container">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    loading="lazy"
                  />
                  <div className="overlay-play">
                    <span className="play-icon">▶</span>
                  </div>
                </div>
                <div className="media-info">
                  <h4 className="media-title">{video.title}</h4>
                  {video.duration && <span className="media-duration">Duration: {video.duration}</span>}
                  <span className="media-language">Language: {video.language}</span>
                </div>
              </div>
            ) : null
          )}
        </div>
      ) : (
        <div className="empty-state">
          <p className="empty-message">No results found for "{searchTerm}" in {language === "both" ? "any language" : language}</p>
          <button className="search-again-btn" onClick={handleBack} aria-label="Try another search">
            Try Another Search
          </button>
        </div>
      )}
    </div>
  );
});

export default PageVideo;